module.exports = __webpack_public_path__ + "static/img/download-flat.4fd8641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download-flat.png
// module id = 475
// module chunks = 173